import { defineQuery, useQuery } from '@pinia/colada'
import { services } from '~/services/composition'
import type { FeaturesModel } from '@trading/core'

const fallbackFeatures: FeaturesModel = {
  branding: {},
  features: {
    allow_change_password: false,
    login_type: 'email'
  }
}

export type PasswordChangeAccessState = 'pending' | 'allowed' | 'denied'

export const useFeaturesQuery = defineQuery(() => {
  const { brand } = useRuntimeConfig().public

  const query = useQuery({
    key: () => ['features', brand],
    query: async () => {
      try {
        return await services.features.getFeatures(brand)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('[features] Failed to load feature flags', error)
        return fallbackFeatures
      }
    },
    enabled: import.meta.client,

    staleTime: 60_000
  })

  const passwordChangeAccessState = computed<PasswordChangeAccessState>(() => {
    if (query.isLoading.value) return 'pending'
    if (!query.error.value && query.data.value?.features.allow_change_password === true) {
      return 'allowed'
    }
    return 'denied'
  })

  return { ...query, passwordChangeAccessState }
})
